import React from 'react';
import { ClearIndicatorProps } from 'react-select';
import classNames from 'classnames';
import styles from '../../../ClearIndicator/styles.module.scss';
import { ClearIcon } from '../../../../ClearIcon';
import { SelectOption } from '../../..';

export function DefaultClearIndicator(
  props: ClearIndicatorProps<SelectOption, false>,
) {
  return (
    <ClearIcon
      innerProps={props.innerProps}
      classNames={classNames(
        'ms-1',
        'me-2',
        'fs-6',
        props.isFocused ? styles['clear-focused'] : styles['clear'],
      )}
    />
  );
}
